import { render, staticRenderFns } from "./DictInput.vue?vue&type=template&id=ee8b8f1c"
import script from "./DictInput.vue?vue&type=script&lang=js"
export * from "./DictInput.vue?vue&type=script&lang=js"
import style0 from "./DictInput.vue?vue&type=style&index=0&id=ee8b8f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports